.root {
  width: 100vw;

  @media (min-width: 768px) {
    height: 100vh;
  }
}
